import React, {useContext} from "react";
import "./Footer.scss";
import {Fade} from "react-reveal";
import emoji from "react-easy-emoji";
import StyleContext from "../../contexts/StyleContext";
import usePortfolio from "../../hooks/usePortfolio";

export default function Footer() {
  const {isDark} = useContext(StyleContext);
  const {footerSection} = usePortfolio();
  return (
    <Fade bottom duration={1000} distance="5px">
      <div className="footer-div">
        <p className={isDark ? "dark-mode footer-text" : "footer-text"}>
          {footerSection.text}
        </p>
        <p className={isDark ? "dark-mode footer-text" : "footer-text"}>
          {footerSection.themeBy}{" "}
          <a href={footerSection.themeLink}>
            {footerSection.themeName}
          </a>
          {" " + footerSection.thanks}
        </p>
      </div>
    </Fade>
  );
}
